<br />
@if (selectedOrg == null) {
  <p>
    &nbsp;&nbsp;&nbsp;&nbsp;You are not currently assigned to any orgs in this application, please contact the administrator.
  </p>
}
